/**
 * waypointColors — functional (category-coding) colors for the waypoint
 * body-motion flow. They pair the in-Canvas 3D markers / route line with the
 * wizard's numbered chips, so start / waypoint / route read as the SAME identity
 * in both surfaces. Unreal convention: the color IS the category, so it
 * deliberately does NOT follow the palette theme — themeable surfaces (panel
 * backgrounds, warnings, dim text) use var(--m-*) tokens instead. Allowlisted as
 * functional in tests/unit/paletteEnforcement.test.mjs.
 *
 * `hex` for CSS / canvas-2D; `num` for THREE material colors.
 */
export const WAYPOINT_COLORS = {
  start:         { hex: '#4ade80', num: 0x4ade80 }, // first waypoint (route origin)
  point:         { hex: '#33ccff', num: 0x33ccff }, // every subsequent waypoint
  routeStraight: { hex: '#facc15', num: 0xfacc15 }, // route line, obstacle-ignoring straight mode
  heading:       { hex: '#f472b6', num: 0xf472b6 }, // heading ticks: the facing each anchor asks for
  anchor:        { hex: '#e879f9', num: 0xe879f9 }, // one dot per root_xz point the request carries
  routeNavmesh:  { hex: '#33ff99', num: 0x33ff99 }, // route line, navmesh mode
  badgeText:     { hex: '#04121a', num: 0x04121a }, // dark text on a start/point colored badge
  label:         { hex: '#ffffff', num: 0xffffff }, // numbered sprite label on a 3D marker
}
